module.exports = __webpack_public_path__ + "gh.d9949341.svg";